import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { auth } from "../../../firebaseConfig";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

export const readDataS2 = async () => {
  const userId = getSelectedUid(); // Get the selected UID
  // console.log(userId);
  // if (!userId) {
  //   throw new Error("Invalid user.");
  // }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Professional Qualifications"
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      // console.log("Section 2 data:", docSnap.data());
      return docSnap.data(); // Return the form data
    } else {
      // console.log("No such document for Section 2!");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching Section 2 data: ", error);
    return null;
  }
};
